const initZhDingZhXianKey = () => {
  const mainAndSup = mainKey => {
    return {
      mainKey,
      supKey: '',
      groupKey: ''
    }
  }

  return {
    'REPEATABLE:MATCH:ORDER:1': mainAndSup('zd_1'),
    'REPEATABLE:MATCH:ORDER:2': mainAndSup('zd_2'),
    'REPEATABLE:MATCH:ORDER:3': mainAndSup('zd_3'),
    'REPEATABLE:MATCH:ORDER:4': mainAndSup('zd_4'),
    'REPEATABLE:2:MATCH:1:0': mainAndSup('zsh_2'),
    'REPEATABLE:2:MATCH:0:2': mainAndSup('zsh_2'),
    'REPEATABLE:3:MATCH:1:0': mainAndSup('zsh_3'),
    'REPEATABLE:3:MATCH:1:1': mainAndSup('zsh_3'),
    'REPEATABLE:3:MATCH:0:3': mainAndSup('zsh_3'),
    'REPEATABLE:4:MATCH:1:0': mainAndSup('zsh_4'),
    'REPEATABLE:4:MATCH:1:1': mainAndSup('zsh_4'),
    'REPEATABLE:4:MATCH:2:0': mainAndSup('zsh_4'),
    'REPEATABLE:4:MATCH:1:2': mainAndSup('zsh_4'),
    'REPEATABLE:4:MATCH:0:4': mainAndSup('zsh_4')
  }
}

export default {
  ...initZhDingZhXianKey()
}
